import type { ResourcePage, Transport, TransportRequest } from '../../../services/controlTowerApi';
import { controlTowerApi, type OverviewQuery, paramsFor } from '../../../services/controlTowerApi';

// Separate endpoint names keep accumulated graph pages out of the original view's cache.
const mergePage = <T extends { id: string }>(cache: ResourcePage<T>, incoming: ResourcePage<T>, offset: number) => {
    if (offset === 0) {
        return incoming;
    }
    const items = new Map(cache.items.map(item => [item.id, item]));
    incoming.items.forEach(item => {
        items.set(item.id, item);
    });
    return { ...incoming, items: [...items.values()] };
};

export const liveGraphApi = controlTowerApi.injectEndpoints({
    endpoints: builder => ({
        liveGraphRequests: builder.query<ResourcePage<TransportRequest>, OverviewQuery>({
            providesTags: ['TransportData'],
            query: query => `/control-tower/transport-requests?${paramsFor(query)}`,
            serializeQueryArgs: ({ endpointName, queryArgs }) =>
                JSON.stringify([endpointName, { ...queryArgs, offset: 0 }]),
            merge: (cache, incoming, { arg }) => mergePage(cache, incoming, arg.offset),
            forceRefetch: ({ currentArg, previousArg }) => currentArg?.offset !== previousArg?.offset,
        }),
        liveGraphTransports: builder.query<ResourcePage<Transport>, OverviewQuery>({
            providesTags: ['TransportData'],
            query: query => `/control-tower/transports?${paramsFor(query)}`,
            serializeQueryArgs: ({ endpointName, queryArgs }) =>
                JSON.stringify([endpointName, { ...queryArgs, offset: 0 }]),
            merge: (cache, incoming, { arg }) => mergePage(cache, incoming, arg.offset),
            forceRefetch: ({ currentArg, previousArg }) => currentArg?.offset !== previousArg?.offset,
        }),
    }),
});

export const { useLiveGraphRequestsQuery, useLiveGraphTransportsQuery } = liveGraphApi;
